// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"444":"4401ebb9df45d1ee","8674":"c13fed90528850de"}[chunkId] + ".css";
};